<template>
    <div class="form-group row">
        <div class="col-lg-12">
            <!--begin::Dropzone-->
            <div class="dropzone dropzone-queue mb-2" :id="'kt_dropzone_' + id">
                <!--begin::Controls-->
                <div class="dropzone-panel mb-lg-0 mb-2">
                    <a class="dropzone-select btn btn-sm btn-primary me-2">{{$t('auth.add_file')}}</a>
                    <a class="dropzone-remove-all btn btn-sm btn-light-primary">{{ $t('auth.delete_all') }}</a>
                </div>
                <!--end::Controls-->

                <!--begin::Items-->
                <div class="dropzone-items wm-200px">
                    <div class="dropzone-item" style="display:none">
                        <!--begin::File-->
                        <div class="dropzone-file">
                            <div class="dropzone-filename" title="nom_de_fichier.jpg">
                                <span data-dz-name>nom_de_fichier.jpg</span>
                                <strong>(<span data-dz-size>340kb</span>)</strong>
                            </div>

                            <div class="dropzone-error" data-dz-errormessage></div>
                        </div>
                        <!--end::File-->

                        <!--begin::Progress-->
                        <div class="dropzone-progress">
                            <div class="progress">
                                <div
                                    class="progress-bar bg-primary"
                                    role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress>
                                </div>
                            </div>
                        </div>
                        <!--end::Progress-->

                        <!--begin::Toolbar-->
                        <div class="dropzone-toolbar">
                            <span class="dropzone-cancel" data-dz-remove style="display: none;"><i class="bi bi-x fs-3"></i></span>
                            <span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span>
                        </div>
                        <!--end::Toolbar-->
                    </div>
                </div>
                <!--end::Items-->
            </div>
            <!--end::Dropzone-->

            <!--begin::Hint-->
            <span class="form-text text-muted">{{$t('auth.file_size')}} {{ this.maxSizes }} {{$t('auth.file_number')}} {{ this.maxFiles}}.</span>
            <!--end::Hint-->
        </div>
    </div>

</template>

<script>

    export default {

      props: {
        id: {required: true},
        maxFiles: {required: true, type: Number},
        maxSizes : {required: true ,type:Number},
        modelValue: {
          type: Array,
          required: true
        }
      },

      data(){
        return {
          content: this.modelValue
        }
      },


      mounted(){
        this.dropzoneFilesUpload()
      },

      methods: {
        dropzoneFilesUpload(){
          // set the dropzone container id
          var id = '#kt_dropzone_' + this.id;
          // set the preview element template
          var previewNode = $(id + " .dropzone-item");
          previewNode.id = "";
          var previewTemplate = previewNode.parent('.dropzone-items').html();
          previewNode.remove();

          var myDropzone4 = new Dropzone(id, { // Make the whole body a dropzone
              url: window.api_url, // Set the url for your upload script location
              parallelUploads: 20,
              previewTemplate: previewTemplate,
              maxFilesize: this.maxSizes, // Max filesize in MB
              maxFiles: this.maxFiles,
              autoQueue: false, // Make sure the files aren't queued until manually added
              previewsContainer: id + " .dropzone-items", // Define the container to display the previews
              clickable: id + " .dropzone-select" // Define the element that should be used as click trigger to select files.
          });

          myDropzone4.on("addedfile", (file) => {
            // Hookup the start button
            if(this.maxFiles === 1){
              this.content[0] = file
              this.content = [...this.content];
            }else {
              this.content.push(file)
            }
            this.updateContent()
            $(document).find(id + ' .dropzone-item').css('display', '');
            $(id + " .progress").css('display', 'inline-block');
          });

          myDropzone4.on("removedfile", (file) => {
            let files = this.content.filter(arrayFile => arrayFile !== file)
            this.content = files
            this.updateContent()
            if(myDropzone4.files.length < 1){
                $(id + " .dropzone-upload, " + id + " .dropzone-remove-all").css('display', 'none');
            }
          });
        },

        updateContent () {
          this.$emit('update:modelValue', this.content)
        }
      },
    }
</script>

<style scoped>

</style>
